export const flightReservationShow: any = {
  flightSummary: "Flight Summary",
  travelerInfo: "Travelers Information",
  flightDetails: "Flight Details",
  priceSummary: "Price Summary",
  regulation: "Rules & Restrictions",
  help: "Help",
};
